import React, { Component } from 'react';
import TicketListContainer from './TicketListContainer';

export default class TicketContainer extends Component {

    render() {
        return <TicketListContainer />;
    }
}